import React from "react";
import { Modal, Button } from "react-bootstrap";
import "./SessionTimeoutModal.scss";

const SessionTimeoutModal = ({ show, isRenewing, onKeepWorking, onLogout }) => {
  return (
    <Modal
      show={show}
      backdrop="static"
      keyboard={false}
      centered
      enforceFocus
      className="custom-pop-up session-timeout-modal"
      aria-labelledby="session-timeout-title"
      onHide={() => {}}
    >
      <Modal.Header>
        <Modal.Title id="session-timeout-title">
          Your Session Will Soon Expire
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Your Admin Portal session is idle and will expire shortly.
          If you wish to continue working, click{" "}
          <strong>&quot;Keep Working.&quot;</strong> To end your session, click{" "}
          <strong>&quot;Logout.&quot;</strong> If no action is taken, you will
          be logged out automatically.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={onLogout}
          disabled={isRenewing}
        >
          Logout
        </Button>
        <Button
          variant="primary"
          onClick={onKeepWorking}
          disabled={isRenewing}
        >
          {isRenewing ? "Keep Working..." : "Keep Working"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SessionTimeoutModal;
